// extracted by css-extract-rspack-plugin
export default {"level_tag":"styles-module__level_tag--OiH6i"};